import root from '../../utils/root';
import warn from '../../utils/warnings/warn';
import fetchJSON from '../../utils/fetch/fetchJSON';
import { getExperimentIdsAsString, getVariantionIdsAsString } from '../vwo';
import config from '../config';
import defaultPhoneDataStructure from './defaultPhoneV3';
import getProduct from '../getProduct';

const url = config.invocaPhoneV3;

/**
 * @private
 * Gets common parameters.
 *
 * @param  {Object} data - the payload data object to fulfill and send
 * @param  {Object} hcStorage - the `hc` object in the storage
 * @return {Object}
 */
function getCommonParameters(data, hcStorage) {
  const replaceRegex = /medicareguide\.com$/.test(document.domain) ? /(?:stg|local|qa|www)\./i : /(?:stg|local|qa)\./i;

  data.product = getProduct(document.domain);
  data.src = hcStorage.source;
  data.publisher_click_id = hcStorage.gclid || hcStorage.msclkid;
  data.session_id = hcStorage.healthcareSession || hcStorage.sid;
  data.user_id = hcStorage.healthcareUserId || hcStorage.uid;
  data.sub_id = hcStorage.subid;
  data.state = hcStorage.location.state_acronym;
  data.zip = hcStorage.location.zip_code;
  data.request_url = `${root.location.host}${root.location.pathname}${root.location.search}`;
  data.experiment_id = getExperimentIdsAsString();
  data.variation_id = getVariantionIdsAsString();
  data.device = hcStorage.Device;
  data.site = document.domain.replace(replaceRegex, '');
  return data;
}

/**
 * Gets the phone number from invoca using endpoint v3
 *
 * @param  {Object} options - parameters to send:
 *  {
 *    "product": {String} (optional)
 *    "src": {String} (optional)
 *    "publisher_click_id": {String} (optional)
 *    "session_id": {String} (optional)
 *    "user_id": {String} (optional)
 *    "sub_id": {String|Number} (optional)
 *    "experiment_id": {String} (optional)
 *    "variation_id": {String} (optional)
 *    "device": {String} (required)
 *    "placement": {String} (required)
 *    "state": {String} (optional)
 *    "zip": {String} (optional)
 *    "request_url": {String} (optional)
 *    "site": {String} (optional)
 *  }
 * @return {Promise}
 */
function getInvocaPhoneV3({hcStorage, options = {}}) {
  const payload = Object.assign(getCommonParameters(defaultPhoneDataStructure, hcStorage), options);
  return fetchJSON({
    // https://github.com/healthcarecom/sem-content#get-phone-number-version-3
    url, // invoca phone
    data: payload,
  })
    .catch((error) => {
      warn(error, {
        url,
        data: payload,
      });
      return {
        status: 404,
      };
    });
}

export default getInvocaPhoneV3;
